import React, { FC, useState } from "react";
import { Button, Checkbox } from "@skyportal/ui-kit";
import cn from "classnames";
import { useTranslation } from "react-i18next";

import BucketModalShell from "../BucketModalShell";
import shellStyles from "../BucketModalShell/BucketModalShell.module.css";
import { EXPORT_COLUMNS } from "../constants";
import { BaseBucketModalProps, ExportColumn } from "../types";

import styles from "./ExportBucketsModal.module.css";

interface Props extends BaseBucketModalProps {}

const ExportBucketsModal: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation("storageOverview");
  const [selected, setSelected] = useState<ExportColumn[]>([...EXPORT_COLUMNS]);
  const isExportDisabled = selected.length === 0;

  const toggle = (col: ExportColumn) => {
    setSelected((prev) => (prev.includes(col) ? prev.filter((c) => c !== col) : [...prev, col]));
  };

  const handleExport = (type: "csv" | "pdf") => {
    if (isExportDisabled) {
      return;
    }

    console.log("EXPORT", { type, columns: selected });
    onClose();
  };

  return (
    <BucketModalShell
      open={open}
      onClose={onClose}
      title={t("modals.export.title")}
      controls={
        <div className={cn(shellStyles.controls, styles.controls)}>
          <Button type="secondary" onClick={onClose}>
            {t("common:Cancel")}
          </Button>
          <Button onClick={() => handleExport("csv")} disabled={isExportDisabled}>
            {t("modals.buttons.csv")}
          </Button>
          <Button onClick={() => handleExport("pdf")} disabled={isExportDisabled}>
            {t("modals.buttons.pdf")}
          </Button>
        </div>
      }
    >
      <div className={cn(shellStyles.body, styles.body)}>
        <div className={styles.list}>
          {EXPORT_COLUMNS.map((col) => (
            <div key={col} className={styles.item}>
              <Checkbox checked={selected.includes(col)} onChange={() => toggle(col)} size="small" />
              <span className={styles.label}>{t(`table.columns.${col}`)}</span>
            </div>
          ))}
        </div>
        {isExportDisabled && <div className={styles.errorText}>{t("modals.validation.exportColumnsRequired")}</div>}
      </div>
    </BucketModalShell>
  );
};

export default ExportBucketsModal;
